import { DtoHasApi } from './dto-has-api.model';
import { Api } from 'src/core/decorators/dto/api.decorator';

@Api('api/app/user')
export class UserBatchUpdateDepartmentDto extends DtoHasApi {
  departmentId: number;
  userIds: string[];
}
